import Snap from 'snapsvg-cjs';

const sectionScoresSlider = () => {
    let s = Snap('.js-scores-slider-anim');
    if (s) {
        const circle = s.circle(1600, 340, 320);
        circle.attr({
            fill: 'transparent',
            stroke: '#ff0050',
            strokeWidth: '2px',
        });
    }
};

export default sectionScoresSlider;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-scores-slider.js